import { freightHandlingUnitIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const setDefaultFreightHandlingUnit = {
  name: "setDefaultFreightHandlingUnit" as const,
  input: z.object({ id: freightHandlingUnitIdFormat.schema }),
  output: z.object({}),
};
